import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

const ActivitiesLeftTab = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    return (
        <div className="additional-information">
            <div className="list">
                <ul>
                    <li className='text-black'>
                        <Link to="/activities/GreenCampus">
                            <i className="fas fa-leaf"></i> <span>Green Campus</span>
                        </Link>
                    </li>
                    <li className='text-black'>
                        <Link to="/activities/it-finishing-school">
                            <i className="fas fa-laptop-code"></i> <span>IT Finishing School</span>
                        </Link>
                    </li>
                    <li className='text-black'>
                        <Link to="/activities/obe">
                            <i className="fas fa-cogs"></i> <span>OBE</span>
                        </Link>
                    </li>
                    <li className='text-black'>
                        <Link to="/activities/ncc">
                            <i className="fas fa-flag"></i> <span>NCC</span>
                        </Link>
                    </li>
                    <li className='text-black'>
                        <Link to="/activities/nss">
                            <i className="fas fa-hands-helping"></i> <span>NSS</span>
                        </Link>
                    </li>
                    <li className='text-black'>
                        <Link to="/activities/nss/previous-years">
                            <i className="fas fa-history"></i> <span>NSS Previous Years Activities</span>
                        </Link>
                    </li>
                    <li className='text-black'>
                        <Link to="/activities/sswec">
                            <i className="fas fa-users"></i> <span>SSSWES</span>
                        </Link>
                    </li>
                    <li className='text-black'>
                        <Link to="/activities/college-magazine">
                            <i className="fas fa-book-open"></i> <span>College Magazine</span>
                        </Link>
                    </li>
                </ul>

            </div>
        </div>
    )
}

export default ActivitiesLeftTab
